/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogInputReal } from "../../d-dialog-input-real";
import { DThemeDarkDialogInput } from "./d-theme-dark-dialog-input";

export class DThemeDarkDialogInputReal
	extends DThemeDarkDialogInput
	implements DThemeDialogInputReal {}
